<div class="container">
    @if (url) {
        <ng-container>
            <iframe (load)="onLoad()" [src]="url" class="iframe" title="iframe-call"></iframe>
            <div class="tp-close">
                <button (click)="close()" mat-raised-button color="primary">
                    {{ "Close" | translate }}
                </button>
            </div>
        </ng-container>
    }
    @if (showLoading()) {
        <div class="mask">
            <i class="spinner"></i>
        </div>
    }
</div>
